<div class="content-container">
  <div class="slide-container-vudu">

    <!-- Page 0 - General Info -->
    <div class="content-vudu">
      <div class="import-logo-container">
        <img class="logo-vudu" src="./assets/images/vudu_btn.png" alt="Vudu">
        <span class="arrow-icon">→</span>
        <img class="logo-cc" src="./assets/images/cc_logo.png" alt="CheapCharts">
      </div>
      <p>{{getString('importVuduPage1Text1')}}</p>
      <p>{{getString('importVuduPage1Text2')}}</p>
      <p>{{getString('importVuduPage1Text3')}}</p>
    </div>

    <!-- Page 1 - Chrome Extension Info -->
    <div class="content-vudu">
      <h2>{{getString('stepByStep')}}</h2>
      
      <div class="extension-info-simple">
        <img class="extension-icon" src="https://lh3.googleusercontent.com/XLDe1NHC3XUJXzj1MAh3iPdQEhjGAUFNJwEVwejyQdpTPeMz58qtCjroGWKdcfIuBvBftDX748WpPh_hjM8gcRnYGQ=s60" alt="Fandango At Home Catalog">
        <div class="extension-name">
          <strong>Fandango At Home Catalog</strong>
          <div class="extension-subtitle">Chrome Extension</div>
        </div>
      </div>

      <p>{{getString('importVuduPage2Text1')}}</p>
      
      <ol class="instruction-list">
        <li>
          <span [innerHTML]="getString('importVuduPage2Text2')"></span>
          <br>
          <a class="extension-install-link" href="https://chromewebstore.google.com/detail/fandango-at-home-catalog/bnlpiockcfehbfbdcegahemgmjfkdopc" target="_blank">
            {{getString('installExtension')}}
          </a>
        </li>
        <li>{{getString('importVuduPage2Text3')}}</li>
        <li>{{getString('importVuduPage2Text4')}}</li>
        <li>{{getString('importVuduPage2Text5')}}</li>
        <li>{{getString('importVuduPage2Text6')}}</li>
      </ol>
    </div>

    <!-- Page 2 - File Upload -->
    <div class="content-vudu">
      <div *ngIf="!isUploading">
        <h2>{{getString('uploadYourFile')}}</h2>
        <p>{{getString('importVuduPage3Text1')}}</p>
        
        <button type="button" class="blue-button" (click)="chooseFile()">{{getString('choose')}}</button>
        
        <div class="file-status">
          <span *ngIf="fileOK == true" class="green-text">{{getString('fileOK')}}</span>
          <span *ngIf="invalidFile == true" class="red-text">{{getString('invalidVuduFile')}}</span>
          <span *ngIf="fileTooBig == true" class="red-text">{{getString('fileExceeds10MB')}}</span>
        </div>
        
        <input #browseInput type="file" accept=".csv,.txt" (change)="handleSelectedLocalFiles($event)" class="browse-input" value="Browse">

        <p>{{getString('importVuduPage3Text2')}}</p>
        <div class="media-selection-box">
          <app-custom-checkbox [value]="moviesOn" [label]="getString('movies')" (onChange)="cbMoviesChanged($event)"></app-custom-checkbox>
          <app-custom-checkbox [value]="tvOn" [label]="getString('tv')" (onChange)="cbTVChanged($event)"></app-custom-checkbox>
        </div>
        
        <p class="note-text">{{getString('importVuduPage3Text3')}}</p>
        
        <div class="red-text error-message">
          {{errorMessage}}
        </div>
      </div>
      <div *ngIf="isUploading" class="spinner-container">
        <app-spinner></app-spinner>
        <div>{{getString('pleaseWait')}}</div>
      </div>
    </div>

    <!-- Page 3 - Result -->
    <div class="content-vudu">
      <div class="result-page">
        <h1 *ngIf="uploadSuccessful" class="green-text">{{getString('importSuccessful')}}</h1>
        <h1 *ngIf="!uploadSuccessful" class="red-text">{{getString('importFailed')}}</h1>
        
        <div class="response-message-box">
          <h3>Server Response:</h3>
          <pre class="response-message">{{responseMessage}}</pre>
        </div>
        
        <div *ngIf="uploadSuccessful" class="import-stats-box">
          <div class="import-stat-row">
            <span class="import-stat-label">{{getString('importVuduPage4SuccessPrefix')}}</span>
            <span class="import-stat-number">{{successCount}}</span>
            <span class="import-stat-label">{{getString('importVuduPage4SuccessSuffix')}}</span>
          </div>
          <div *ngIf="skippedCount > 0" class="import-stat-row">
            <span class="import-stat-number">{{skippedCount}}</span>
            <span class="import-stat-label">{{getString('importVuduPage4SkippedSuffix')}}</span>
          </div>
          <div *ngIf="skippedCount > 0" class="import-stat-explanation">{{getString('importVuduPage4SkippedExplanation')}}</div>
          <div *ngIf="unknownCount > 0" class="import-stat-row">
            <span class="import-stat-number">{{unknownCount}}</span>
            <span class="import-stat-label">{{getString('importVuduPage4UnknownSuffix')}}</span>
          </div>
          <div *ngIf="unknownCount > 0" class="import-stat-explanation">{{getString('importVuduPage4UnknownExplanation')}}</div>
        </div>
      </div>
    </div>

  </div>
  <div class="page-number">{{currentPageNo + 1}}/{{pages}}</div>
  <div class="btn-container">

    <button type="button" class="back-button float-left" (click)="back()" *ngIf="currentPageNo > 0 && currentPageNo < pages">{{getString('back')}}</button>

    <button type="button" class="blue-button float-right"
      (click)="next()"
      *ngIf="currentPageNo < pages - 1 && !isUploading"
    >
      <span *ngIf="currentPageNo != 2">{{getString('next')}}</span>
      <span *ngIf="currentPageNo == 2">{{getString('start')}}</span>
    </button>
    <button type="button" class="blue-button float-right" (click)="close()" *ngIf="currentPageNo == pages - 1">
      {{getString('done')}}
    </button>
  </div>

</div>
